import React from 'react';

/**
 * 테이블 데이터를 전처리한다.
 * - apartment_number + size_type 기준 중복 제거
 * - total_households 문자열 → 숫자 변환
 *
 * @param {Array|null} data
 * @returns {{ preprocessedData: Array, isDataFullyLoaded: boolean }}
 */
export function useTablePreprocess(data) {
  const preprocessedData = React.useMemo(() => {
    if (!data || !Array.isArray(data) || data.length === 0) return [];

    const uniqueItems = new Map();

    data.forEach(item => {
      const newItem = { ...item };

      if (newItem.total_households !== null && newItem.total_households !== undefined) {
        if (typeof newItem.total_households === 'string') {
          newItem.total_households = parseFloat(newItem.total_households.replace(/,/g, '')) || 0;
        }
      } else {
        newItem.total_households = 0;
      }

      const uniqueKey = `${newItem.apartment_number}_${newItem.size_type || newItem.size_no || ''}`;
      uniqueItems.set(uniqueKey, newItem);
    });

    return Array.from(uniqueItems.values());
  }, [data]);

  const isDataFullyLoaded = React.useMemo(() => {
    return data && Array.isArray(data) && data.length > 0 &&
      data.every(item => item.hasOwnProperty('total_households'));
  }, [data]);

  return { preprocessedData, isDataFullyLoaded };
}
